import { api } from './api'

export const fetchCustomer = (query) => api.get('/customer', query)
export const searchCustomer = (query) => api.get('/customer/search', query)
export const fetchTotalCustomer = (query) => api.get('/customer/count', query)
export const syncCustomer = () => api.post('/customer/sync')
export const fetchCustomerAddress = (customerId) => api.get('/customer/address', { customerId })
export const updateCustomerAddress = (query) => api.put('/customer/address', query)
